<template>
  <div class="staff-basic">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="mailbackup/home2"
      @before-fetch="beforeFetch"
    >
      <el-table-column slot="dir" label="目录">
        <template v-slot="{row}">
          <el-button type="text" @click="goToDetail(row)">{{row.dir}}</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'file-detail',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [
        {
          prop: 'search',
          placeholder: '邮箱',
          clearable: true
        }],
      columns: [
        { prop: 'email', label: '邮箱', width: 240 },
        { slot: 'dir' },
        { prop: 'number', label: '邮件数' }
      ],
      fileId: location.href.split('/')[location.href.split('/').length - 1]
    }
  },
  created() {

  },
  methods: {
    goToDetail (row) {
      this.$router.push(`/backup/email/list/${row.email}/${encodeURIComponent(row.dir)}`)
    },
    beforeFetch(data) {
      if (this.fileId) {
        data.email = this.fileId
      }
    }
  }
}
</script>

<style lang="scss">
</style>
